import { render, staticRenderFns } from "./CAP0560M.vue?vue&type=template&id=0b30eb20&scoped=true&"
import script from "./CAP0560M.vue?vue&type=script&lang=js&"
export * from "./CAP0560M.vue?vue&type=script&lang=js&"
import style0 from "./CAP0560M.vue?vue&type=style&index=0&id=0b30eb20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b30eb20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
